module.exports = __webpack_public_path__ + "static/media/image1.0fac256a.png";